<template>
  <a :href="source" class="link-container" target="_blank" rel="noopener nofollow">
    <span class="icon" :class="`icon-${icon}`"></span>
    <span class="text">{{ title }}</span>
  </a>
</template>

<script>
const URL_REG_EXP = /(^\w+:|^)\/\/|\/$/g;
const DEFAULT_CATEGORY = 'OTHER';

export default {
  name: 'ProjectCategory',
  props: {
    category: String,
    source: String,
  },
  data() {
    return {
      categories: {
        [DEFAULT_CATEGORY]: {
          title: 'mysite.ru',
          icon: 'site',
        },
        HOPSHOP: {
          title: `${this.$t('common.hopshop')}`,
          icon: 'shop',
        },
        TELEGRAM: {
          title: 'Telegram',
          icon: 'telegram',
        },
        INSTAGRAM: {
          title: 'Instagram',
          icon: 'instagram',
        },
        YOUTUBE: {
          title: 'Youtube',
          icon: 'youtube',
        },
        TWITCH: {
          title: 'Twitch',
          icon: 'twitch',
        },
        TAPLINK: {
          title: 'Taplink',
          icon: 'taplink',
        },
      },
    };
  },
  computed: {
    preparedSource() {
      if (URL_REG_EXP.test(this.source)) {
        return this.source.replace(URL_REG_EXP, '');
      }

      return this.source;
    },
    title() {
      if (this.$validate.isUndefined(this.category) || this.$validate.isNull(this.category)) {
        return this.preparedSource;
      }

      if (this.category === DEFAULT_CATEGORY) {
        return this.preparedSource;
      }

      return this.categories[this.category].title;
    },
    icon() {
      if (this.$validate.isUndefined(this.category) || this.$validate.isNull(this.category)) {
        return this.categories[DEFAULT_CATEGORY].icon;
      }

      return this.categories[this.category].icon;
    },
  },
};
</script>

<style lang="sass" scoped>
  .link-container
    width: 100%
    display: inline-flex
    align-items: center
    font-size: 14px
    line-height: 17px
    color: #9B51E0
    text-decoration: underline

  .text
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap

  .icon
    width: 22px
    height: 22px
    flex: none
    background-position: center
    background-repeat: no-repeat
    background-size: auto
    margin-right: 4px

  .icon-information
    background-image: url('~@/assets/svg/information.svg')

  .icon-site
    background-image: url('~@/assets/svg/site.svg')

  .icon-shop
    background-image: url('~@/assets/svg/shop.svg')

  .icon-telegram
    background-image: url('~@/assets/svg/telegram.svg')

  .icon-instagram
    background-image: url('~@/assets/svg/instagram.svg')

  .icon-youtube
    background-image: url('~@/assets/svg/youtube.svg')

  .icon-twitch
    background-image: url('~@/assets/svg/twitch.svg')

  .icon-taplink
    background-image: url('~@/assets/svg/taplink.svg')
</style>
